module.exports = __webpack_public_path__ + "media/images/emblems/Essertines-sur-Rolle-coat_of_arms-19a562fdd5577884c14ed41955be6e6b.svg";